.section {
    margin: 0 0 15px 0;
    padding: 0;
}

.heading {
    /* Source text is lowercase ("info") so font-variant renders it as
       uniform small caps, matching dibdev. */
    font-variant: small-caps;
    /* A global reset sets `font-synthesis: none`; Lato has no true
       small-cap glyphs, so without re-enabling synthesis small-caps
       silently falls back to plain lowercase. */
    font-synthesis: small-caps;
    font-size: 18px;
    letter-spacing: normal;
    color: #969696;
    font-weight: 600;
    /* Top margin is 15px (not dibdev's 30px) to absorb the 16px
       padding-top on the column wrapper (.related in
       ContentLayoutLEGACY) and land the first heading ~30px from the
       column edge to match dibdev visually. */
    margin: 0 0 15px 0;
    padding-bottom: 0;
    border-bottom: 1px solid #b1b7be;
    line-height: 1.4;
}

.name {
    font-size: 15px;
    color: rgb(51, 51, 51);
    line-height: 1.55;
}

.date {
    display: block;
    font-size: 15px;
    color: rgb(51, 51, 51);
    margin: 0;
    line-height: 1.55;
}
